import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  deleteDocusignRedirectData,
  getDocusignRedirectUrl,
} from '../../../../../utils/helpers/docusignRedirecUtils';

const DocusignRedirect = (props) => {
  const { user, isLoading } = props;
  const {
    config: { issuerId },
  } = useSelector((state) => state.issuerConfiguration);

  const redirectUrl = getDocusignRedirectUrl(user.investorId, issuerId);

  useEffect(
    () => () => deleteDocusignRedirectData(issuerId, user.investorId),
    [],
  );

  return isLoading ? null : <Redirect to={redirectUrl} />;
};

DocusignRedirect.defaultProps = {
  user: {},
  isLoading: true,
};

DocusignRedirect.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const {
    auth: { user, isLoading },
  } = state;
  return {
    user: user || {},
    isLoading,
  };
};

export default connect(mapStateToProps, {})(DocusignRedirect);
